module.exports = __webpack_public_path__ + "img/product-hunt-cat.6f4ca275.png";